<template>
  <div class="flex hv-70 flex-col lg:flex-row mt-24 ">
    <Sidebar @select-service="handleServiceSelect" :activeProduct="selectedProductId" />
    <MainContent :selectedProduct="selectedProduct" />
  </div>
</template>

<script setup>
import { ref, onMounted, watch, computed } from 'vue';
import { useRoute } from 'vue-router';
import { useI18n } from 'vue-i18n';
import Sidebar from '@/components/services/SidebarCom.vue';
import MainContent from '@/components/services/MainContentCom.vue';

const route = useRoute(); // للحصول على المعرف من المسار
const { tm, locale } = useI18n();

const selectedProduct = ref(null);
const selectedProductId = ref(route.params.selectedFeature || null);

// دالة لجلب مسار الصورة الرئيسية
const getMainImageUrl = (id) => {
  return new URL(`../assets/Backend/services/service${id}/main.png`, import.meta.url).href;
};

// دالة لجلب صور المعرض
const getGalleryImages = (id) => {
  const images = [];
  for (let i = 1; i <= 3; i++) {
    images.push(new URL(`../assets/Backend/services/service${id}/${i}.png`, import.meta.url).href);
  }
  return images;
};

// دالة لجلب تفاصيل العنصر بناءً على المعرف من البيانات الثابتة
const fetchProductById = (id) => {
  const services = tm('servicesData');
  if (Array.isArray(services)) {
    const service = services.find(s => s.id == id);
    if (service) {
      return {
        ...service,
        main_image: getMainImageUrl(service.id),
        images: getGalleryImages(service.id)
      };
    }
  }
  return null;
};

// جلب بيانات العنصر عند تحميل الصفحة
onMounted(() => {
  if (selectedProductId.value) {
    selectedProduct.value = fetchProductById(selectedProductId.value);
  }
});

// تحديث البيانات عند تغيير معرف العنصر في الـ route
watch(() => route.params.selectedFeature, (newFeatureId) => {
  if (newFeatureId) {
    selectedProductId.value = newFeatureId;
    selectedProduct.value = fetchProductById(newFeatureId);
  }
});

// إعادة جلب البيانات عند تغيير اللغة
watch(() => locale.value, () => {
  if (selectedProductId.value) {
    selectedProduct.value = fetchProductById(selectedProductId.value);
  }
});

// معالجة التحديد من القائمة الجانبية
const handleServiceSelect = (product) => {
  selectedProduct.value = fetchProductById(product.id);
  selectedProductId.value = product.id;
};
</script>
